import React from 'react';
import Link from '../../common/TrackedLink';
import renderHTML from 'react-render-html';
import LazyLoad from 'react-lazyload';

const Testimonial = ({ imgSrc1, alt1, imgSrc2, alt2, quote, submitted, readLink, link }) => {
	return (
		<section className="row testimonial">
			<div className="col sm-6 image">
				<LazyLoad once={ true } offset={ 200 }>
					<img
						className="icon"
						src={ imgSrc1 }
						alt={ alt1 }
					/>
				</LazyLoad>
			</div>
			<div className="col sm-6 content">
				<LazyLoad once={ true } offset={ 200 }>
					<img
						src={ imgSrc2 }
						alt={ alt2 }
					/>
				</LazyLoad>
				<p className="quote">&ldquo;{ renderHTML(quote) }&rdquo;</p>
				<p className="submission">
					Submitted by { renderHTML(submitted) }
				</p>
				<Link to={ link } className="arrow-link">
					{ renderHTML(readLink) }
				</Link>
			</div>
		</section>
	);
};

export default Testimonial;


// WEBPACK FOOTER //
// ./src/pages/category/common/Testimonial.js